module.exports = __webpack_public_path__ + "img/cover.aaf8f9b7.jpg";